import ConfirmationModal from "Components/Atoms/ConfirmationModal";
import SingleSelect from "Components/Atoms/select/SingleSelect";
import { useAppDispatch, useAppSelector } from "Redux/hooks";
import { moveUsers } from "feature/admin/actions";
import {
  selectAllOtherOrganizations,
  selectOrganizationById,
} from "feature/admin/slice";
import { Organization, User } from "feature/admin/types";
import { useState } from "react";
import { useParams } from "react-router-dom";

type DialogContentProps = {
  selected: Organization | null;
  setTargetOrganization: (value: Organization) => void;
};

function DialogContent({
  setTargetOrganization,
  selected,
}: DialogContentProps) {
  const { orgId } = useParams();
  const currentOrganizationId = orgId || "";

  const items = useAppSelector((state) =>
    selectAllOtherOrganizations(state, currentOrganizationId)
  );
  return (
    <SingleSelect
      keyExtractor={(item) => item.organisation_id}
      value={selected}
      items={items}
      renderLabel={(item) =>
        item !== null ? item.name : "Select new organization"
      }
      renderOption={(item) => <p>{item.item?.name}</p>}
      onChange={(item) => {
        if (item) setTargetOrganization(item);
      }}
    />
  );
}

type Props = {
  users: User[];
};

function MoveUsersButton({ users }: Props) {
  const dispatch = useAppDispatch();
  const { orgId } = useParams();
  const currentOrganizationId = orgId || "";
  const [confirmMoveOperation, setConfirmMoveOperation] = useState(false);
  const [targetOrganization, setTargetOrganization] =
    useState<Organization | null>(null);
  const userIds = users.map(({ user_id }) => user_id);
  const currentOrganization = useAppSelector((state) =>
    selectOrganizationById(state, currentOrganizationId)
  );

  const onMoveUsers = () => {
    setConfirmMoveOperation(true);
  };

  const onContinue = () => {
    if (!targetOrganization) return;

    dispatch(
      moveUsers({
        currentOrganizationId,
        newOrganizationId: targetOrganization.organisation_id,
        userIds,
      })
    );
  };

  const onCancel = () => {
    setConfirmMoveOperation(false);
    setTargetOrganization(null);
  };

  return (
    <>
      <button
        type="button"
        className="inline-flex items-center rounded bg-white px-2 py-1 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-30 disabled:hover:bg-white"
        onClick={onMoveUsers}
      >
        Move
      </button>
      <ConfirmationModal
        isOpen={confirmMoveOperation}
        title="Move users"
        content={
          <div className="flex h-32 w-full flex-col justify-between">
            <p>
              {`Move ${userIds.length} user${userIds.length === 1 ? "" : "s"} ${
                currentOrganization?.name ? "from" : ""
              } `}
              <b>{currentOrganization?.name}</b> to{" "}
              <b>{targetOrganization?.name}</b>
            </p>
            <DialogContent
              selected={targetOrganization}
              setTargetOrganization={setTargetOrganization}
            />
          </div>
        }
        onContinue={onContinue}
        canContinue={!!targetOrganization}
        onCancel={onCancel}
      />
    </>
  );
}

export default MoveUsersButton;
